import { Profile } from "@app/core/auth/Profile.model";

export class AuthState {
  accessToken: string;
  refreshToken: string;
  user: Profile;
  loading: boolean;
}
